import React from "react";

import { IMG_URl } from "../../common/img_url";
import { indexStore } from "../../store/indexStore";
import Visibility from "../utils/Visibility";
import { useTranslation } from "react-i18next";
import ProductModel from "../../Models/PorductModel";
import UAEDirhamIcon from "../utils/UAEDirhamIcon";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "../ui/sheet";
import { ProductCartElement } from "../ProductScrens/ProductElemnts";
import OptionsProduct from "../OptionsProduct/OptionsProduct";
import { useNavigate, useParams } from "react-router-dom";
import { GrAdd } from "react-icons/gr";
type ProductRowProps = {
  item: ProductModel;
  displayWaygrid: boolean;
  onClick: (item: ProductModel) => void;
};
function ProductRow(props: ProductRowProps) {
  const { name, description } = indexStore();
  const { t } = useTranslation();

  return (
    <Visibility visible={!props.item.hidden}>
      <div
        className={`flex flex-col border-2 border-primary/20 shadow-card-shadow rounded-2xl overflow-hidden bg-background transition-all duration-300 hover:shadow-lg hover:border-primary/40 hover:-translate-y-1 h-full`}
        key={props.item.id}
      >
        {/* Clickable area (image + content) */}
        <button
          type="button"
          onClick={() => props.onClick(props.item)}
          className="flex flex-col text-left h-full cursor-pointer"
        >
          {/* Product image - full width on top with quick add button */}
          <div className="relative">
            <img
              src={`${IMG_URl}${props.item.image}`}
              alt="img"
              className={`w-full object-cover ${props.displayWaygrid
                ? "aspect-[4/3] md:aspect-[3/2]"
                : "aspect-[5/3] md:aspect-[16/9]"
                }`}
            />
            {/* Quick Add to Cart button (opens sheet) */}
            {/* <div className="absolute top-2 left-2 md:top-3 md:left-3">
              <QuickAddSheet product={props.item} />
            </div> */}
          </div>

          {/* Content */}
          <div className="flex flex-col gap-3 p-3 md:p-4 flex-1">
            <ProductMed
              item={props.item}
              t={t}
              name={name as keyof ProductModel}
              description={description as keyof ProductModel}
              displayWaygrid={props.displayWaygrid}
            />

            <div className="flex items-end justify-between gap-3">
              <ProductPrice
                displayWaygrid={props.displayWaygrid}
                item={props.item}
                name={name}
              />
            </div>
          </div>
        </button>
      </div>
    </Visibility>
  );
}

export default ProductRow;

// ============================================================================
// Quick Add Sheet Component (per-card add-to-cart with options)
// ============================================================================

const QuickAddSheet = ({ product }: { product: ProductModel }) => {
  const { name } = indexStore();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [optionsSelected, setOptionsSelected] = React.useState<any[]>([]);

  return (
    <Sheet>
      <SheetTrigger asChild>
        <button
          onClick={(e) => e.stopPropagation()}
          className="px-2 py-1.5 rounded-lg bg-primary text-onPrimary text-xs md:text-sm font-semibold shadow-md hover:bg-primary/90 active:scale-95 transition-all duration-200"
        >
         <GrAdd className="w-5 h-5 text-onPrimary" />
        </button>
      </SheetTrigger>
      <SheetContent
        side="bottom"
        className="flex flex-col gap-4 bg-background border-t-2 border-primary/20 rounded-t-2xl max-h-[75vh] overflow-y-auto"
      >
        <SheetHeader className="px-1 pt-4 pb-2">
          <SheetTitle className="text-base md:text-lg font-bold text-foreground">
            {String(product[name as keyof ProductModel] ?? "")}
          </SheetTitle>
        </SheetHeader>

        <div className="flex flex-col gap-4 px-1 pb-4">
          {/* Options selection (إن وُجدت خيارات لهذا المنتج) */}
          <Visibility visible={!!product.options && product.options.length > 0}>
            <OptionsProduct
              options={product.options as any}
              name={name}
              price={product.price_offer || product.price}
              setOptionsSelected={setOptionsSelected}
              optionsSelected={optionsSelected}
            />
          </Visibility>

          {/* نفس زر إضافة السلة المستخدم في صفحة المنتج */}
          <ProductCartElement
            product={product}
            t={t}
            navigate={navigate}
            params={{ branch_id: params.branch_id ?? "" }}
            optionsSelected={optionsSelected}
            itemLoading={false}
            productSheet={true}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};

const ProductMed = ({
  item,
  t,
  name,
  description,
  displayWaygrid,
}: {
  item: ProductModel;
  t: any;
  name: keyof ProductModel;
  description: keyof ProductModel;
  displayWaygrid: boolean;
}) => {
  return (
    <div
      className={`flex flex-col justify-between gap-2 flex-1 min-w-0 ${displayWaygrid ? "w-full" : ""
        }`}
    >
      <div className="flex flex-col gap-1.5">
        <p className="text-sm md:text-base capitalize text-onBackground font-bold text-ellipsis line-clamp-1">
          {String(item[name as keyof ProductModel] ?? "")}
        </p>
        <p className="text-xs md:text-sm text-onBackground/80 text-ellipsis line-clamp-2">
          {String(item[description as keyof ProductModel] ?? "")}
        </p>
      </div>
      <ProductTags item={item} t={t} />
    </div>
  );
};
const ProductTags = ({ item, t }: { item: ProductModel; t: any }) => {
  const baseTagClass =
    "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold";

  const hasAnyTag = item.new || item.unavailable || item.popular;

  return (
    <div className="flex gap-1.5 flex-wrap">
      <Visibility visible={!!item.new}>
        <span
          className={`${baseTagClass} bg-primary/10 text-primary border border-primary/30`}
        >
          {t("gloabl.new")}
        </span>
      </Visibility>
      <Visibility visible={!!item.popular}>
        <span
          className={`${baseTagClass} bg-emerald-50 text-emerald-700 border border-emerald-200`}
        >
          {t("gloabl.common")}
        </span>
      </Visibility>
      <Visibility visible={item.unavailable}>
        <span
          className={`${baseTagClass} bg-destructive/10 text-destructive border border-destructive/30`}
        >
          {t("gloabl.unavailable")}
        </span>
      </Visibility>

      {/* للحفاظ على ارتفاع ثابت حتى بدون تاغات */}
      {!hasAnyTag && (
        <span className="invisible">{t("gloabl.new")}</span>
      )}
    </div>
  );
};


const ProductPrice = ({
  displayWaygrid,
  item,
  name,
}: {
  displayWaygrid: boolean;
  item: ProductModel;
  name: string;
}) => {
  return (
    <div
      className={`flex shrink-0 justify-end gap-1.5 text-sm md:text-base font-semibold text-onBackground ${displayWaygrid ? "flex-row justify-between w-full" : "flex-col"
        }`}
    >
      <p
        className={`flex items-center gap-1 ${item.price_offer
          ? "line-through decoration-primary decoration-solid decoration-2 text-onBackground/60"
          : ""
          }`}
      >
        <UAEDirhamIcon className="w-3 h-3 md:w-4 md:h-4" />
        {item.price}
      </p>
      <Visibility visible={!!item.price_offer}>
        <p className="text-primary flex items-center gap-1 font-bold">
          <UAEDirhamIcon className="w-3 h-3 md:w-4 md:h-4" /> {item.price_offer}
        </p>
      </Visibility>
    </div>
  );
};
